import * as React from "react"
import { FunctionComponent } from "react"
import { IFlapOutResultProps } from "../../interfaces/i-fact-finder-auto-suggest"

export const FlapOutProductResult: FunctionComponent<IFlapOutResultProps> = (
	props: IFlapOutResultProps
) => {
	const { suggestion } = props

	return (
		<div className="autosuggest__item--event">
			<a href={suggestion.attributes.deepLink} rel="noopener noreferrer" className="autosuggest__link link">
				<p className="autosuggest__type">{suggestion.attributes.seminarTyp}</p>
				<p className="autosuggest__title">{suggestion.name}</p>
				<p className="autosuggest__descr">
					{suggestion.attributes.untertitel}
				</p>
			</a>
		</div>
	)
}
